import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import '../checkout.css';

class DialogPolicy extends Component {
    render() {
        const { dialogPolicy, onAcceptPolicy, CloseDialogCheckOutPolicy, wording } = this.props;
        return (
            <Modal visible={dialogPolicy} width='450' effect='fadeInUp' onClickAway={() => CloseDialogCheckOutPolicy()}>
                <div className='m-20'>
                    <div className='dialog-header'>
                        <h4 style={{ color: '#2d64cf' }}>{wording.checkoutPage.dialogPolicy.title}</h4>
                    </div>
                    <div className='dialog-body policy-warpper mt-20 mb-20'>
                        <p className='policy-title'>{wording.checkoutPage.dialogPolicy.bodyMessage.title}</p>
                        <p>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph1}</p>
                        <p>
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph2}
                            <br />
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph3}
                            <br />
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph4}
                            <br />
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph5}
                        </p>
                        <p>
                            <span>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph6}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph7}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph8}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph9}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph10}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph11}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph12}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph13}</span>
                            <br />
                            <span className='pl-10'>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph14}</span>
                            <br />
                            <span>{wording.checkoutPage.dialogPolicy.bodyMessage.paragraph15}</span>
                        </p>
                        <p>
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph16}
                            <br />
                            {wording.checkoutPage.dialogPolicy.bodyMessage.paragraph17}
                        </p>
                    </div>
                    <div className='dialog-action row'>
                        <div className='col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-dark'
                                onClick={() => {
                                    onAcceptPolicy();
                                    CloseDialogCheckOutPolicy();
                                }}>
                                {wording.checkoutPage.dialogPolicy.ok}
                            </button>
                        </div>
                        <div className='col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-light-red'
                                onClick={() => CloseDialogCheckOutPolicy()}>
                                {wording.checkoutPage.dialogPolicy.cancle}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ checkout, language }) => ({
    dialogPolicy: checkout.dialogPolicy,
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CloseDialogCheckOutPolicy: Actions.CloseDialogCheckOutPolicy
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogPolicy);
